var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "uploadButton", on: { click: _vm.showFileDialog } },
    [
      _c("input", {
        attrs: { type: "file", accept: _vm.limitFileBrowser, multiple: "" },
        on: {
          change: function ($event) {
            return _vm.fileSelected($event)
          },
        },
      }),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }